import React, { PureComponent } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { ArrowBackRounded as ArrowBackIcon } from '@mui/icons-material';
import Grid from "@mui/material/Grid";
import { globalStyles } from '../../theme/index.js';
import Text from '../../components/Text.js';
import Button from '../../components/Button.js';
import Bubble from '../../components/Bubble.js';
import TextInput from '../../components/TextFields/TextInput.js';
import * as Theme from '../../theme/index.js';
import PricingDesignForm from './PricingDesignForm.js';
import Revisions from './Revisions.js';
import { fetchTelusDrugIDs } from '../../services/helpers.js';
import NumberInput from '../../components/TextFields/NumberInput.js';
import Loader from '../../components/Loader.js';
import * as Services from '../../services/index.js';
class ClassPricingContainer extends PureComponent {
  state = {
    value: 0,
    designIDs: this.props.designs[this.props.selectedClassID] ? Object.keys(this.props.designs[this.props.selectedClassID]) : [],
    selectedDesignID: null,
    showPricingForm: false,
    telusDrugPlanID: null,
    showPastPricing: false,
    drugPlanIDs: [],
    coverages: {
      solo: 0,
      duo: 0,
      family: 0
    }
  };
  async componentDidMount() {
    const design = this.props.designs[this.props.selectedClassID][this.state.designIDs[0]];
    const drugPlanIDs = await fetchTelusDrugIDs();
    let readyData = drugPlanIDs.map(row => row.DrugPlanIDs);
    let coverages = this.state.coverages;
    if (this.props.quote) {
      coverages = {
        solo: this.props.quote.classes[this.props.selectedClassID].coverages.solo,
        duo: this.props.quote.classes[this.props.selectedClassID].coverages.duo,
        family: this.props.quote.classes[this.props.selectedClassID].coverages.family
      };
    }
    this.setState({
      selectedDesignID: this.state.designIDs[0],
      telusDrugPlanID: design.telusDrugPlanID || null,
      drugPlanIDs: readyData,
      coverages
    });
    const designPricing = design.pricing.bare || design.pricing; // TODO: change this to just design.pricing once all pricing has been udpdated

    if (!isNaN(designPricing.drugs.solo)) {
      this.setState({
        showPricingForm: true
      });
    }
  }
  static getDerivedStateFromProps(props, state) {
    const designIDs = props.designs[props.selectedClassID] ? Object.keys(props.designs[props.selectedClassID]) : [];
    if (designIDs.length !== state.designIDs.length) {
      return {
        designIDs,
        value: designIDs.length - 1,
        selectedDesignID: designIDs[designIDs.length - 1],
        telusDrugPlanID: null
      };
    }
    return null;
  }

  /**
   * @param type
   * @param amount
   * @private
   */
  _handleCoveragesChange = (type, amount) => {
    this.setState({
      coverages: {
        ...this.state.coverages,
        [type]: amount
      }
    });
  };
  _saveCoverages = async () => {
    const soloCoverageError = await Services.validateInput('checkEmpty', this.state.coverages.solo);
    const duoCoverageError = await Services.validateInput('checkEmpty', this.state.coverages.duo);
    const familyCoverageError = await Services.validateInput('checkEmpty', this.state.coverages.family);
    this.setState({
      soloCoverageError,
      duoCoverageError,
      familyCoverageError
    });
    if (soloCoverageError || duoCoverageError || familyCoverageError) {
      return;
    }
    this.props.saveCoverages(this.props.selectedClassID, this.state.coverages);
  };
  _handleTabChange = (event, value) => {
    const design = this.props.designs[this.props.selectedClassID][this.state.designIDs[value]];
    this.setState({
      value,
      selectedDesignID: this.state.designIDs[value],
      telusDrugPlanID: design.telusDrugPlanID || null
    });
    const designPricing = design.pricing.bare || design.pricing; // TODO: change this to just design.pricing once all pricing has been udpdated

    if (!isNaN(designPricing.drugs.solo)) {
      this.setState({
        showPricingForm: true
      });
    }
  };
  _handleDrugPlanIDChange = e => {
    const value = e.target.value;
    this.setState({
      telusDrugPlanID: value
    });
    this.props.saveTelusDrugPlanID(value, this.state.selectedDesignID, this.props.selectedClassID);
  };
  _toggleRevisions = () => {
    this.setState({
      showingRevisions: !this.state.showingRevisions
    });
  };
  render() {
    const {
      designs,
      selectedClassID,
      selectedClass
    } = this.props;
    const {
      selectedDesignID,
      drugPlanIDs
    } = this.state;
    const styles = {
      container: globalStyles.containerControlSite,
      content: globalStyles.content,
      contentBlock: globalStyles.contentBlock,
      tabSelected: globalStyles.tabSelected,
      tabsIndicator: globalStyles.tabsIndicator,
      saveBtn: {
        display: 'block',
        marginLeft: 'auto',
        marginTop: "20px !important"
      },
      header: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-between"
      },
      headerTitleBlock: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center'
      },
      pricingBlock: {
        border: "1.5px solid #F1F1F1",
        paddingLeft: 30,
        paddingRight: 30,
        borderRadius: 5,
        marginTop: 20
      },
      pricingBlockHeader: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-between"
      },
      block: {
        border: "1.5px solid #F1F1F1",
        paddingLeft: 30,
        paddingRight: 30,
        borderRadius: 5,
        marginTop: 20
      },
      headerBorder: {
        borderBottom: "1.5px solid #F1F1F1"
      },
      tabsRoot: {
        // borderBottom: `1px solid ${ Theme.colors.borderGrey }`
      },
      tabRoot: {
        "&.MuiTab-root": {
          fontFamily: "AvenirLTPro-Medium",
          color: Theme.colors.mainTextGrey,
          textTransform: 'capitalize',
          minWidth: '160px'
        },
        "&.MuiTab-root.Mui-selected": {
          color: Theme.colors.skyBlue
        }
      }
    };
    if (!selectedDesignID || this.state.drugPlanIDs.length === 0) {
      return /*#__PURE__*/React.createElement(Loader, {
        isContainer: true
      });
    }
    if (this.state.showingRevisions) {
      return /*#__PURE__*/React.createElement(Revisions, {
        selectedClassID: selectedClassID,
        selectedDesignID: this.state.selectedDesignID,
        accountID: this.props.currentAccountMeta.accountID,
        commissions: this.props.commissions,
        designs: designs,
        pricing: designs[selectedClassID][this.state.selectedDesignID].pricing,
        getPricingRevisions: this.props.getPricingRevisions,
        getSinglePricingRevision: this.props.getSinglePricingRevision,
        goBack: this._toggleRevisions
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      style: styles.contentBlock
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.header
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.headerTitleBlock
    }, /*#__PURE__*/React.createElement(Button, {
      customStyle: styles.backBtn,
      onClick: this.props.goBack,
      transparent: true
    }, /*#__PURE__*/React.createElement(ArrowBackIcon, null)), /*#__PURE__*/React.createElement(Text, {
      extraLarge: true,
      bold: true,
      display: "block",
      margin: "20px 0"
    }, "Plan Pricing")), /*#__PURE__*/React.createElement(Button, {
      color: "white",
      noHover: true,
      customStyle: {
        height: 50,
        width: 180,
        marginRight: "10px",
        textTransform: "capitalize",
        fontSize: 16
      },
      onClick: this._toggleRevisions
    }, "View Revisions"), /*#__PURE__*/React.createElement(Bubble, {
      label: `Class: ${selectedClass.title}`,
      isSelected: true,
      clickable: false
    })), !designs[selectedClassID] || Object.keys(designs[selectedClassID]).length === 0 ? /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, "The advisor has not created any plan designs yet for this class. Please check with the Advisor or come back later.") : /*#__PURE__*/React.createElement(React.Fragment, null, this.props.quote && /*#__PURE__*/React.createElement("div", {
      style: {
        paddingBottom: 20,
        marginBottom: 30,
        ...styles.pricingBlock
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.headerBorder
    }, /*#__PURE__*/React.createElement(Text, {
      large: true,
      display: "block",
      margin: "20px 0 10px 0",
      color: Theme.colors.skyBlue
    }, "Class Coverage Types")), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      margin: "10px 0 0 0"
    }, "Please provide the number of Solo, Duo and Family members for this class. We will use these values to drive the pricing breakdown for the Advisor."), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: "# Solo Members",
      fullWidth: true,
      variant: "outlined",
      value: this.state.coverages.solo,
      onChange: e => this._handleCoveragesChange('solo', e.target.value),
      error: this.state.soloCoverageError
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: "# Duo Members",
      fullWidth: true,
      variant: "outlined",
      value: this.state.coverages.duo,
      onChange: e => this._handleCoveragesChange('duo', e.target.value),
      error: this.state.duoCoverageError
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: "# Family Members",
      fullWidth: true,
      variant: "outlined",
      value: this.state.coverages.family,
      onChange: e => this._handleCoveragesChange('family', e.target.value),
      error: this.state.familyCoverageError
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 3
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: this._saveCoverages,
      color: "primary",
      customStyle: {
        height: 50,
        width: 180,
        textTransform: "capitalize",
        fontSize: 16
      }
    }, "Save Coverages")))), /*#__PURE__*/React.createElement(Tabs, {
      value: this.state.value,
      onChange: this._handleTabChange,
      indicatorColor: "primary",
      textColor: "primary",
      sx: {
        ...styles.tab
      }
    }, Object.keys(designs[selectedClassID]).map((designID, i) => {
      const design = designs[selectedClassID][designID];
      return /*#__PURE__*/React.createElement(Tab, {
        key: `${design.title}-${i}`,
        label: designID === selectedClass.planDesignID ? `${design.title} (Active)` : design.title,
        sx: {
          ...styles.tabRoot
        }
      });
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        paddingBottom: 20,
        ...styles.pricingBlock
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.headerBorder
    }, /*#__PURE__*/React.createElement(Text, {
      large: true,
      display: "block",
      margin: "20px 0 10px 0",
      color: Theme.colors.skyBlue
    }, "Telus Drug Plan")), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      margin: "10px 0 0 0"
    }, "Please provide the Telus Drug Plan ID for this plan design. You can locate the different options in Telus AdjudiCare."), /*#__PURE__*/React.createElement(TextInput, {
      label: "Telus Drug Plan ID",
      value: this.state.telusDrugPlanID || '',
      onChange: this._handleDrugPlanIDChange,
      select: true,
      fullWidth: true,
      variant: "outlined",
      selectOptions: window.location.hostname.includes('staging') || window.location.hostname.includes('localhost') ? ['12734'] : drugPlanIDs
    })), /*#__PURE__*/React.createElement("div", {
      style: styles.pricingBlock
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        ...styles.header,
        ...(this.state.showPricingForm ? styles.headerBorder : {})
      }
    }, /*#__PURE__*/React.createElement(Text, {
      large: true,
      display: "block",
      margin: "20px 0",
      color: Theme.colors.skyBlue
    }, "Pricing"), this.props.quote && /*#__PURE__*/React.createElement(Button, {
      onClick: () => this.setState({
        showPastPricing: !this.state.showPastPricing
      }),
      color: "primary",
      marginTop: "40px",
      marginBottom: "40px"
    }, "Toggle Past Rates")), /*#__PURE__*/React.createElement(PricingDesignForm, {
      classID: selectedClassID,
      designID: this.state.selectedDesignID,
      classData: this.props.classData,
      designs: this.props.designs,
      commissions: this.props.commissions,
      accountID: this.props.currentAccountMeta.accountID,
      pricing: designs[selectedClassID][this.state.selectedDesignID].pricing,
      savePricing: this.props.savePricing,
      savePricingInput: this.props.savePricingInput,
      quote: this.props.quote,
      isQuote: this.props.isQuote,
      isRevision: this.props.isRevision,
      showPastPricing: this.state.showPastPricing,
      loader: this.props.loader
    }))), this.props.loader?.isLoading && this.props.loader.type === 'container' && /*#__PURE__*/React.createElement(Loader, {
      isContainer: true
    }));
  }
}
export default ClassPricingContainer;